import React, { useEffect, useState } from 'react';
import Container from '../../Container/Container';
import { get, post } from '../../ApiServices/ApiServices';
import Loader from '../Component/Loader';
import { useNavigate, Link } from 'react-router';
import { useSelector } from 'react-redux';

function CoatPantSize() {
    const [Matching, setMatching] = useState([]);
    const [coatStyleData, setCoatStyleData] = useState([]);
    const [pantData, setPantData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [coatLoading, setCoatLoading] = useState(true);
    const [editCell, setEditCell] = useState(null);
    const [editValue, setEditValue] = useState('');
    const navigate = useNavigate();
    const profile = useSelector((state) => state.profile.profile);
    const isAdmin = profile?.name === "Admin";
    const GetMatching = async () => {
        try {
            const api = `get-matched-pant-styles`;
            const response = await get(api);
            if (response?.status === true) {
                console.log(response?.data?.rows, "response matching");
                setMatching(response?.data);
            }
        } catch (err) {
            if (err?.message === "Invalid or expired token" || err?.message === "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
            console.error("Error fetching matched pant styles:", err);
        }
    };

    const GetCoatStyles = async () => {
        try {
            const api = `coat-pant-styles?inventory_category_id=1`;
            const response = await get(api);
            if (response?.status === true) {
                console.log(response?.data, "coat styles response");
                setCoatStyleData(response?.data);
            }
        } catch (err) {
            if (err?.message === "Invalid or expired token" || err?.message === "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
            console.error("Error fetching coat styles:", err);
        } finally {
            setCoatLoading(false);
        }
    };

    useEffect(() => {
        GetMatching();
        GetCoatStyles();
    }, []);

    // Group coat data by style to get unique styles with their categories and sizes
    const styleMap = {};
    coatStyleData.forEach(item => {
        const style = item?.mapping?.style;
        const category = item?.category;
        const mappingId = item.mapping_id || item.mapping?.id || item.id;

        if (style && !styleMap[style]) {
            styleMap[style] = {
                style: style,
                categories: {}
            };
        }
        if (style && category) {
            const sizes = item.sizes || [];
            styleMap[style].categories[category] = {
                sizes: sizes,
                minSize: sizes.length > 0 ? Math.min(...sizes) : null,
                maxSize: sizes.length > 0 ? Math.max(...sizes) : null,
                mapping_id: mappingId
            };
        }
    });

    // Get all unique categories
    const allCategories = [...new Set(coatStyleData.map(item => item.category))].sort((a, b) => {
        const order = ['Boys', 'Short', 'Regular', 'Long', 'Extra Long'];
        return order.indexOf(a) - order.indexOf(b);
    });

    // Convert to array for rendering
    const uniqueStyles = Object.values(styleMap);

    const GetPantStyles = async () => {
        try {
            const api = `coat-pant-styles?inventory_category_id=2`;
            const response = await get(api);

            if (response?.status) {
                console.log("Raw API Response:", response.data);
                const styleMap = {};

                response.data.forEach((item) => {
                    const style = item.mapping?.style;
                    const category = item.category;
                    const sizes = item.sizes || [];
                    const mappingId = item.mapping_id || item.mapping?.id || item.id;

                    console.log(`Processing item:`, { style, category, mappingId, item });

                    if (!styleMap[style]) {
                        styleMap[style] = {
                            style: style,
                            mapping_id: mappingId,
                            boyWaistMin: null,
                            boyWaistMax: null,
                            menWaistMin: null,
                            menWaistMax: null,
                            boyMappingId: null,
                            menMappingId: null,
                        };
                    }

                    if (category.toLowerCase() === "boys") {
                        const minSize = Math.min(...sizes);
                        const maxSize = Math.max(...sizes);
                        styleMap[style].boyWaistMin = styleMap[style].boyWaistMin === null ? minSize : Math.min(styleMap[style].boyWaistMin, minSize);
                        styleMap[style].boyWaistMax = styleMap[style].boyWaistMax === null ? maxSize : Math.max(styleMap[style].boyWaistMax, maxSize);
                        styleMap[style].boyMappingId = mappingId;
                    } else {
                        const minSize = Math.min(...sizes);
                        const maxSize = Math.max(...sizes);
                        styleMap[style].menWaistMin = styleMap[style].menWaistMin === null ? minSize : Math.min(styleMap[style].menWaistMin, minSize);
                        styleMap[style].menWaistMax = styleMap[style].menWaistMax === null ? maxSize : Math.max(styleMap[style].menWaistMax, maxSize);
                        styleMap[style].menMappingId = mappingId;
                    }
                });

                const formatted = Object.values(styleMap);
                console.log("Formatted Pant Data:", formatted);
                setPantData(formatted);
            }
        } catch (err) {
            console.error("Error fetching pants styles:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        GetPantStyles();
    }, []);

    // ✅ Handle Double Click for both Coat and Pant
    const handleDoubleClick = (style, field, value, category = null) => {
        setEditCell({ style, field, category });
        setEditValue(value === '-' || value === null ? '' : String(value));
    };

    // ✅ Handle Save (on blur / enter)
    const handleEditComplete = async (style, field, category = null) => {
        if (!editCell) return;

        const updatedValue = editValue.trim() === '' ? null : Number(editValue.trim());

        // Handle Coat Style Edit
        if (category) {
            const currentStyle = uniqueStyles.find(s => s.style === style);
            const categoryData = currentStyle?.categories[category];

            if (!categoryData || !categoryData.mapping_id) {
                console.error("Mapping ID not found for coat:", { style, category });
                alert("Error: Mapping ID not found. Please refresh the page.");
                setEditCell(null);
                setEditValue('');
                return;
            }

            let minValue, maxValue;
            if (field === 'minSize') {
                minValue = updatedValue;
                maxValue = categoryData.maxSize;
            } else {
                minValue = categoryData.minSize;
                maxValue = updatedValue;
            }

            const body = {
                mapping_id: categoryData.mapping_id,
                inventory_category_id: 1,
                min: minValue,
                max: maxValue,
            };

            console.log("Coat API Request Body:", body);

            try {
                const response = await post('coat-pant-styles/edit', body);
                console.log(`✅ Updated Coat ${style} ${category} ${field}:`, updatedValue, response);

                // Refresh coat styles data
                await GetCoatStyles();
            } catch (err) {
                console.error('❌ Error updating coat field:', err);
                if (err?.message?.includes("Token")) {
                    localStorage.removeItem('token');
                    navigate('/login');
                } else {
                    alert(`Failed to update: ${err?.response?.data?.message || err?.message || 'Unknown error'}`);
                }
            } finally {
                setEditCell(null);
                setEditValue('');
            }
            return;
        }

        // Handle Pant Style Edit
        const currentPant = pantData.find(p => p.style === style);

        if (!currentPant) {
            console.error("Pant style not found:", style);
            setEditCell(null);
            setEditValue('');
            return;
        }

        // Determine which category and mapping_id to use
        let minValue, maxValue, mappingId;

        if (field === 'boyWaistMin' || field === 'boyWaistMax') {
            minValue = field === 'boyWaistMin' ? updatedValue : currentPant.boyWaistMin;
            maxValue = field === 'boyWaistMax' ? updatedValue : currentPant.boyWaistMax;
            mappingId = currentPant.boyMappingId;
        } else {
            minValue = field === 'menWaistMin' ? updatedValue : currentPant.menWaistMin;
            maxValue = field === 'menWaistMax' ? updatedValue : currentPant.menWaistMax;
            mappingId = currentPant.menMappingId;
        }

        if (!mappingId) {
            console.error("Mapping ID not found for:", { style, field, currentPant });
            alert("Error: Mapping ID not found. Please refresh the page.");
            setEditCell(null);
            setEditValue('');
            return;
        }

        const body = {
            mapping_id: mappingId,
            inventory_category_id: 2,
            min: minValue,
            max: maxValue,
        };

        console.log("Pant API Request Body:", body);

        // Update local state immediately
        setPantData(prev =>
            prev.map(pant => pant.style === style
                ? { ...pant, [field]: updatedValue }
                : pant
            )
        );

        try {
            const response = await post('coat-pant-styles/edit', body);
            console.log(`✅ Updated Pant ${style} ${field}:`, updatedValue, response);
        } catch (err) {
            console.error('❌ Error updating pant field:', err);
            if (err?.message?.includes("Token")) {
                localStorage.removeItem('token');
                navigate('/login');
            } else {
                alert(`Failed to update: ${err?.response?.data?.message || err?.message || 'Unknown error'}`);
            }
            // Revert on error
            setPantData(prev =>
                prev.map(pant => pant.style === style
                    ? { ...pant, [field]: currentPant[field] }
                    : pant
                )
            );
        } finally {
            setEditCell(null);
            setEditValue('');
        }
    };

    // ✅ Handle Key Events
    const handleKeyDown = (e, style, field, category = null) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleEditComplete(style, field, category);
        } else if (e.key === 'Escape') {
            setEditCell(null);
            setEditValue('');
        }
    };

    // ✅ Render Editable Cell
    const renderCell = (style, field, value, category = null) => {
        const isEditing =
            editCell &&
            editCell.style === style &&
            editCell.field === field &&
            editCell.category === category;

        if (isEditing) {
            return (
                <input
                    type="number"
                    className="form-control form-control-sm"
                    value={editValue}
                    onChange={(e) => setEditValue(e.target.value)}
                    onBlur={() => handleEditComplete(style, field, category)}
                    onKeyDown={(e) => handleKeyDown(e, style, field, category)}
                    autoFocus
                    style={{ width: '80px', padding: '4px' }}
                />
            );
        }
        const isAdmin = profile?.name === "Admin";
        return (
            <span
                onDoubleClick={() => {
                    if (isAdmin) { handleDoubleClick(style, field, value, category) }
                }}
                style={{ cursor: 'pointer', display: 'block', minHeight: '24px', padding: '4px' }
                }
                title="Double-click to edit"
            >
                <b>{value !== null && value !== undefined ? value : '-'}</b>
            </span>
        );
    };

    return (
        <Container>
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content">
                                        <h3 className="nk-block-title page-title">Size Charts</h3>
                                    </div>
                                </div>
                            </div>

                            <div className="card card-preview coatPantStyleTabTable">
                                <div className="card-inner">
                                    <ul className="nav nav-tabs mt-n3 coatPantsstyle">
                                        <li className="nav-item">
                                            <Link className="nav-link active" data-bs-toggle="tab" to="#tabItem1">Coat Style</Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link" data-bs-toggle="tab" to="#tabItem2">Pants Style</Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link" data-bs-toggle="tab" to="#tabItem3">Matching Pants to Coat Styles</Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="tab-content sizeChartTable mt-3">
                                    <div className="tab-pane active" id="tabItem1">
                                        <h5 className="mb-3 ps-3">Coat Size Chart</h5>
                                        {/* <p className="text-muted small ps-3">Double-click on any cell to edit</p> */}
                                        <p className="text-muted mb-3 ps-3">
                                            {isAdmin
                                                ? 'Double-click on any cell to edit.'
                                                : 'You do not have permission to edit values.'}
                                        </p>
                                        <div className="table-responsive">
                                            {coatLoading ? (
                                                <Loader />
                                            ) : (
                                                <table className="table table-striped table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col" rowSpan="2">Coat Style</th>
                                                            {allCategories.map((category, idx) => (
                                                                <th key={idx} scope="col" colSpan="2" className="text-center">{category}</th>
                                                            ))}
                                                        </tr>
                                                        <tr>
                                                            {allCategories.map((category, idx) => (
                                                                <React.Fragment key={idx}>
                                                                    <th scope="col"><b>Min</b></th>
                                                                    <th scope="col"><b>Max</b></th>
                                                                </React.Fragment>
                                                            ))}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {uniqueStyles.length > 0 ? uniqueStyles.map((styleData, index) => (
                                                            <tr key={index}>
                                                                <th scope="row"><b>{styleData.style}</b></th>
                                                                {allCategories.map((category, idx) => {
                                                                    const catData = styleData.categories[category];
                                                                    return (
                                                                        <React.Fragment key={idx}>
                                                                            <td>{renderCell(styleData.style, 'minSize', catData?.minSize, category)}</td>
                                                                            <td>{renderCell(styleData.style, 'maxSize', catData?.maxSize, category)}</td>
                                                                        </React.Fragment>
                                                                    );
                                                                })}
                                                            </tr>
                                                        )) : (
                                                            <tr>
                                                                <td colSpan={allCategories.length * 2 + 1} className="text-center text-muted">No Data Available</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            )}
                                        </div>
                                    </div>

                                    <div className="tab-pane" id="tabItem2">
                                        <h5 className="mb-3 ps-3">Pants Size Chart</h5>
                                        {/* <p className="text-muted small ps-3">Double-click on any cell to edit</p> */}
                                        <p className="text-muted mb-3 ps-3">
                                            {isAdmin
                                                ? 'Double-click on any cell to edit.'
                                                : 'You do not have permission to edit values.'}
                                        </p>
                                        <div className="table-responsive">
                                            {loading ? (
                                                <Loader />
                                            ) : (
                                                <table className="table table-striped table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Pants Style</th>
                                                            <th colSpan="2" className="text-center">Boy's Waist</th>
                                                            <th colSpan="2" className="text-center">Men's Waist</th>
                                                        </tr>
                                                        <tr>
                                                            <th></th>
                                                            <th>Min</th>
                                                            <th>Max</th>
                                                            <th>Min</th>
                                                            <th>Max</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {pantData.length > 0 ? pantData.map((pant, index) => (
                                                            <tr key={index}>
                                                                <td><b>{pant.style}</b></td>
                                                                <td>{renderCell(pant.style, 'boyWaistMin', pant.boyWaistMin)}</td>
                                                                <td>{renderCell(pant.style, 'boyWaistMax', pant.boyWaistMax)}</td>
                                                                <td>{renderCell(pant.style, 'menWaistMin', pant.menWaistMin)}</td>
                                                                <td>{renderCell(pant.style, 'menWaistMax', pant.menWaistMax)}</td>
                                                            </tr>
                                                        )) : (
                                                            <tr>
                                                                <td colSpan="5" className="text-center text-muted">No Data Available</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            )}
                                        </div>
                                    </div>

                                    <div className="tab-pane" id="tabItem3">
                                        <h5 className="mb-3 ps-3">Matching Pants to Coat Styles</h5>
                                        <div className="table-responsive">
                                            <table className="table table-striped table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Coat Styles</th>
                                                        <th scope="col">Pant Styles</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Matching.map((data, index) => (
                                                        <tr key={index}>
                                                            <td><b>{data?.style} {data?.description}</b></td>
                                                            <td><b>{data?.match_pant_style} {data?.Pant?.description}</b></td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    );
}

export default CoatPantSize;